import React from 'react'
import { Button, Modal } from 'react-bootstrap';

const ModalPruebaSM = ({ toggleFunction, modalState }) => {
  const formLink = 'https://forms.gle/U1csuGVWLB9LbaUK7'

  return (
    <Modal show={modalState} onHide={() => toggleFunction(false)} dialogClassName='custom-lg'>
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className='info-container cupos-container cards-center text-center'>
          {/* <img src={img_modal} alt='Apertura del Concurso de Posgrado de Medicina 2024' className='modal-banner sm card' /> */}

          <p className='heading-title fw-semibold mb-2'>Curso Epidemiología de Enfermedades Crónicas</p>

          <p className='fw-semibold fs-int mb-4'>Prevención y Control</p>

          <div className='info-group d-flex flex-column gap-3'>


            <div className='span-group'>
              <span className='fw-semibold'>Modalidad: </span>
              <span>A distancia</span>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Inscripciones: </span>
              <span>Del 13 al 31 de julio de 2026</span>
            </div>

            <div className='span-group'>
              <p className='fw-semibold mb-1'>Dirigido a: </p>

              <ul className='list-start centered mb-1'>
                <li>Estudiantes del último año de Medicina</li>
                <li>Residentes de Posgrado</li>
              </ul>
            </div>

            <div className='span-group'>
              <span className='fw-semibold'>Inicio: </span>
              <span>Agosto de 2026</span>
            </div>

            <div className='span-group mb-2'>
              <span className='fw-semibold'>Finalización: </span>
              <span>Septiembre de 2026</span>
            </div>

            <div className='question-callout lightblue info mb-3'>
              <i className="bi bi-shield-fill-check icon"></i>
              <p className='callout-text'>Curso Válido para el Concurso 2026</p>
            </div>

            <Button className='link-button w-fit px-4 py-2 mx-auto mt-1' target='blank' as='a' variant='primary' href={formLink}>
              Formulario de Inscripción
            </Button>
          </div>

          <div className='info-group mb-2'>
            <p className='fw-semibold mb-0'>Coordinador: Dr. Gilberto Vizcaino</p>
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer>
        <Button className='footer-button' variant="secondary" onClick={()=> toggleFunction(false)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export { ModalPruebaSM }